export default "__VITE_ASSET__HT7_rZBl__"